import styled from "styled-components";

export const ProjectsContainer = styled.div`
  margin-bottom: 100px;
  @media screen and (max-width: 1023px) {
    margin-bottom: 0px;
  }
`;
